import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollbar: SxStyle = {
  height: '60vh',
};

export const options: SxStyle = {
  padding: (p) => p.spacing(1, 2),
  gap: (p) => p.spacing(1.25),
  backgroundColor: (p) => p.palette.grey[50],
};

export const loadingWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  gap: (p) => p.spacing(1),
  padding: (p) => p.spacing(15),
};
